import React, { useEffect, useState } from "react";
import CardItem from "../CardItem";
import Footer from "../Footer";
import Slider from "../Slider";
import banner1 from "../../images/INV.png";
import banner2 from "../../images/CERT.png";
import banner3 from "../../images/DIP.png";
import banner4 from "../../images/DOC.png";
import "./NuestroPortafolio.css";
import { Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

function NuestroPortafolio() {
  return (
    <>
      <Slider />
      <div className="contenido_portafolio">
        <br></br>
        <br></br>
        <div className="intro">
          <p className="intro">
            Puedes seleccionar entre las diferentes categorias que se te
            presentan a continuación para conocer los diferentes servicios
            académicos que el INAP ofrece.
          </p>
        </div>

        <div className="contenedor_portafolio">
          <div className="seccion">
            <div className="descripcion_portafolio">
              <h1 className="titulo1_portafolio">
                Investigación, Asesoria y Asistencia Técnica
              </h1>
              <p className="texto_portafolio">
                El punto de partida de la gestión por resultados de una
                institución pública es el conocimiento de su realidad a nivel
                estratégico, táctico y operativo. A este conocimiento se llega
                mediante herramientas y procedimientos de investigación
                sistemáticos que se aplican con el propósito de entender los
                factores de satisfacción o insatisfacción en el desempeño
                institucional. Es por ello que, el INAP ofrece asesoría y
                asistencia técnica a otras instituciones públicas en el marco de
                su competencia. Además, desarrolla investigaciones aplicadas con
                el objetivo de fortalecer la Administración Pública.
              </p>
              <Link to="/asesorias">
                {" "}
                <Button
                  className="boton_inscripcion"
                  style={{
                    fontFamily: "Gotham-Bold",
                    backgroundColor: "#15b2e7",
                    borderRadius: "20px",
                    width: "295px",
                    color: "white",
                    fontSize: "17px",
                  }}
                >
                  Ver más
                </Button>{" "}
              </Link>
            </div>
            <div>
              <CardItem
                src={banner1}
                text="Ver más"
                label="Ver más"
                path="/asesorias"
                className="cards__item3"
              />
            </div>
          </div>
        </div>
        <div className="contenedor_portafolio">
          <div className="seccion2">
            <div>
              <CardItem
                src={banner2}
                text="Ver Certificaciones"
                label="Ver más"
                path="/Certificaciones"
                className="cards__item4"
              />
            </div>
            <div className="descripcion_portafolio">
              <h1 className="titulo2_portafolio">Certificaciones</h1>
              <p className="texto_portafolio">
                Se extiende de forma conjunta por el INAP y la Oficina Nacional
                de Servicio Civil -ONSEC-. La certificación acredita que el
                funcionario y servidor público posee las calidades y
                conocimientos, referentes a la Administración Pública, en los
                tres niveles establecidos: Básico, Intermedio y Avanzado.
              </p>
              <Link to="/Certificaciones">
                <Button
                  className="boton_inscripcion"
                  style={{
                    fontFamily: "Gotham-Bold",
                    backgroundColor: "#15b2e7",
                    borderRadius: "20px",
                    width: "295px",
                    color: "white",
                    fontSize: "17px",
                  }}
                >
                  Ver Certificaciones
                </Button>{" "}
              </Link>
            </div>
          </div>
        </div>
        <div className="contenedor_portafolio">
          <div className="seccion">
            <div className="descripcion_portafolio">
              <h1 className="titulo1_portafolio">Cursos y Diplomados</h1>
              <p className="texto_portafolio">
                Desarrollar competencias en los participantes para atender las
                necesidades relativas a la gestión por resultados, involucrando
                el desarrollo de la capacidad de análisis, el uso de la
                información para la toma de decisiones dentro de un sistema de
                gestión establecido que responda al manejo de las metodologías e
                instrumentos de presupuestos por resultados.
              </p>

              <Link to="/cursos">
                {" "}
                <Button
                  className="boton_inscripcion"
                  style={{
                    fontFamily: "Gotham-Bold",
                    backgroundColor: "#15b2e7",
                    borderRadius: "20px",
                    width: "295px",
                    color: "white",
                    fontSize: "17px",
                  }}
                >
                  Ver Curso y Diplomados
                </Button>{" "}
              </Link>
            </div>
            <div>
              <CardItem
                src={banner3}
                text="Ver Cursos y Diplomados"
                label="Ver más"
                path="/cursos"
                className="cards__item3"
              />
            </div>
          </div>
        </div>
        <div className="contenedor_portafolio">
          <div className="seccion2">
            <div>
              <CardItem
                src={banner4}
                text="Ver Maestrías y Doctorado"
                label="Ver más"
                path="/posgrados"
                className="cards__item4"
              />
            </div>
            <div className="descripcion_portafolio">
              <h1 className="titulo2_portafolio">Estudios de Postgrados</h1>
              <p className="texto_portafolio">
                En alianza y coordinación con el ICAP, INAP ofrece
                educación científica y académica de alto nivel a profesionales
                del sector público y privado que están involucrados en la toma
                de decisiones dentro de la Administración Pública. Sus programas
                están orientados a proporcionar herramientas para que el
                funcionario público pueda incidir en la reforma del Estado y en
                la transformación y modernización de la Administración Pública.
              </p>
              <Link to="/posgrados">
                {" "}
                <Button
                  className="boton_inscripcion"
                  style={{
                    fontFamily: "Gotham-Bold",
                    backgroundColor: "#15b2e7",
                    borderRadius: "20px",
                    width: "295px",
                    color: "white",
                    fontSize: "17px",
                  }}
                >
                  Ver Maestrías y Doctorado
                </Button>{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NuestroPortafolio;
